import { ArrowDownTrayIcon, PhotoIcon, XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react'
import { previewDocument } from '../../utils/miscFunctions';

interface IPreviewImage {
    onClose:()=> void;
    imgURL: string;
}
const PreviewImage = ({onClose, imgURL}:IPreviewImage) => {
  return (
  <div className="flex items-center justify-center">
                {/* Backdrop with blur effect */}
                <div 
                    className="absolute inset-0 bg-transparent transition-opacity duration-300"
                    onClick={onClose}
                />
                
                {/* Main modal container */}
                <div className="relative z-10 w-full max-w-7xl h-[90vh] mx-4 flex flex-col">
                    {/* Header with close button and image info */}
                    <div className="flex items-center justify-between p-4 bg-gray-900/80 rounded-t-xl border-b border-gray-700">
                        <div className="flex items-center space-x-2">
                            <span className="text-sm text-gray-300">Image Preview</span>
                        </div>
                        <button 
                            onClick={onClose}
                            className="p-2 rounded-full hover:bg-gray-700/50 transition-colors duration-200 group"
                            aria-label="Close modal"
                        >
                            <XMarkIcon className="w-5 h-5 text-gray-300 group-hover:text-white" />
                        </button>
                    </div>
                    {/* Image container with loading state */}
                    <div className="relative flex-1 flex items-center justify-center bg-gradient-to-br from-gray-900 to-gray-800 overflow-hidden">
                        {/* Loading skeleton */}
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="animate-pulse flex flex-col items-center space-y-2">
                                <PhotoIcon className="w-12 h-12 text-gray-600" />
                                <span className="text-sm text-gray-500">Loading image...</span>
                            </div>
                        </div>
                        {/* Image with smooth loading */}
                        <img
                            src={imgURL}
                            alt="Enlarged view"
                            className="max-w-full max-h-[calc(90vh-64px)] object-contain transition-all duration-500 ease-in-out transform hover:scale-105 cursor-zoom-in"
                            onLoad={(e) => {
                                const img = e.currentTarget;
                                img.style.opacity = '1';
                                img.previousElementSibling?.classList.add('opacity-0');
                            }}
                            style={{ opacity: 0 }} // Will be set to 1 after load
                        />
                    </div>
                    {/* Footer with actions */}
                    <div className="flex items-center justify-between p-3 bg-gray-900/80 rounded-b-xl border-t border-gray-700">
                        <div className="flex items-center space-x-2">
                            <button
                                onClick={()=>previewDocument(imgURL)}
                                className="p-2 text-gray-300 hover:text-white hover:bg-gray-700/50 rounded-full transition-colors duration-200"
                                title="Download"
                            >
                                <ArrowDownTrayIcon className="w-5 h-5" />
                            </button>
                            <span className="text-xs text-gray-400">
                                {new URL(imgURL).pathname.split('/').pop()}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
  )
}

export default PreviewImage